import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=c71d0cba&scoped=true"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"
import style0 from "./Master.vue?vue&type=style&index=0&id=c71d0cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71d0cba",
  null
  
)

export default component.exports